import styled from "styled-components";

export const Root = styled.div`
  position: absolute;
  inset: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  background: ${(props) => props.theme.colors?.white ?? "#FFFFFF"};
  box-sizing: border-box;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 750px;
  flex: 1;
  min-height: 0;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex-shrink: 0;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const MessagesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 8px 0;
`;

export const MessageRow = styled.div`
  display: flex;
  flex-direction: column;
  align-self: ${(props) => (props.$isUser ? "flex-end" : "flex-start")};
  max-width: ${(props) => (props.$isUser ? "85%" : "100%")};
  width: ${(props) => (props.$isUser ? "auto" : "100%")};
`;

export const MessageBubble = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 12px;
  border-radius: 8px;
  background: ${(props) =>
    props.theme.colors?.backgroundGray ?? "#F5F5F5"};
`;

export const InputBar = styled.div`
  width: 100%;
  min-height: 80px;
  flex-shrink: 0;
`;
